import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCamera2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"camera-2, picture, image, cam"} maskId="square-filled-radius-0-stroke-1-IconCamera2"><path fillRule="evenodd" clipRule="evenodd" d="M8.25785 5C9.06446 3.7949 10.4391 3 12 3C13.5609 3 14.9355 3.7949 15.7422 5H22L22 21H2.00001L2 5H8.25785ZM8.25 12.5C8.25 10.4289 9.92893 8.75 12 8.75C14.0711 8.75 15.75 10.4289 15.75 12.5C15.75 14.5711 14.0711 16.25 12 16.25C9.92893 16.25 8.25 14.5711 8.25 12.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCamera2;
